import { IDateRelationValidatorConfig } from '@shared/forms/validators/models/date-relation-validator.model';

// ENUMS #############################################################
export enum FormValidatorIdentifierEnum {
	DATE_RELATION = 'dateRelation',
	MAX_LENGTH = 'maxLength',
	MIN_LENGTH = 'minLength',
	PATTERN = 'pattern',
	REQUIRED = 'required',
	REQUIRED_CUSTOM = 'requiredCustom'
}

export enum FormValidatorVariantEnum {
	CONDITIONAL = 'conditional',
	INITIAL = 'initial'
}


// INTERFACES ########################################################
export interface IFormChangeValue<T> {
	new: T;
	previous: T;
}

interface IValidatorVariantInitial {
	type: FormValidatorVariantEnum.INITIAL;
}


interface IValidatorVariantConditional {
	conditionIsValid: boolean;
	type: FormValidatorVariantEnum.CONDITIONAL;
}

export interface IFormValidatorConfigBase {
	identifier: FormValidatorIdentifierEnum;
	isEnabled: boolean;
	variant: ValidatorVariant;
}

export interface IFormValidatorConfigBaseWithChild extends IFormValidatorConfigBase {
	identifierChild: string
}

export interface IFormValidatorDateRelationConfig extends IFormValidatorConfigBaseWithChild {
	identifier: FormValidatorIdentifierEnum.DATE_RELATION;
	config: IDateRelationValidatorConfig;
}

export interface IFormValidatorMaxLengthConfig extends IFormValidatorConfigBase {
	identifier: FormValidatorIdentifierEnum.MAX_LENGTH;
	length: number;
}

export interface IFormValidatorMinLengthConfig extends IFormValidatorConfigBase {
	identifier: FormValidatorIdentifierEnum.MIN_LENGTH;
	length: number;
}

export interface IFormValidatorPatternConfig extends IFormValidatorConfigBase {
	identifier: FormValidatorIdentifierEnum.PATTERN;
	pattern: string | RegExp;
}

export interface IFormValidatorRequiredConfig extends IFormValidatorConfigBase {
	identifier: FormValidatorIdentifierEnum.REQUIRED;
}

export interface IFormValidatorRequiredCustomConfig extends IFormValidatorConfigBase {
	identifier: FormValidatorIdentifierEnum.REQUIRED_CUSTOM;
	errorKey: string;
}

export interface IFormValueChangeCallback<FormProp, FormValues> {
	cbFn: ( formValueChangesMap: FormChangeValueMapType<FormProp, FormValues> ) => void;
	listenToChanges?: FormProp[];
}

// TYPES #############################################################
export type FormValidatorsConfig<FormProp extends string> = Record<FormProp, FormValidatorsConfigMap>;
export type FormValidatorsConfigMap = Map<FormValidatorIdentifierEnum, FormValidatorConfigType[]>;

type ValidatorVariant =
	IValidatorVariantConditional
	| IValidatorVariantInitial;

export type FormValidatorConfigType =
	IFormValidatorDateRelationConfig
	| IFormValidatorMaxLengthConfig
	| IFormValidatorMinLengthConfig
	| IFormValidatorPatternConfig
	| IFormValidatorRequiredConfig
	| IFormValidatorRequiredCustomConfig;


export type FormChangeValueMapType<FormProp, FormValues> =
	Map<FormProp, IFormChangeValue<Partial<FormValues>>>;


// CLASS #############################################################

